// extracted by mini-css-extract-plugin
module.exports = {"Introduction":"Introduction_Introduction__QyBCy"};